"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (text) {
    var words = text.match(/[A-Za-z][a-z]*/g) || [];
    return words.join(' ');
});
